var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrowSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.76202 12.762C7.44472 13.0793 6.93028 13.0793 6.61298 12.762L0.925476 7.07452C0.608175 6.75722 0.608175 6.24278 0.925476 5.92548L6.61298 0.237976C6.93028 -0.0793247 7.44472 -0.0793247 7.76202 0.237976C8.07933 0.555277 8.07933 1.06972 7.76202 1.38702L2.64905 6.5L7.76202 11.613C8.07933 11.9303 8.07933 12.4447 7.76202 12.762Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowSmall);
export default __webpack_public_path__ + "static/media/leftArrowSmall.012f2d1096e4088417cbc561d7767ae9.svg";
export { ForwardRef as ReactComponent };